(function () {
  document.documentElement.classList.remove('no-js');

  function markShopifyCaptchaForms() {
    [
      'UnifiedContactForm',
      'LessonsApplicationContactForm',
      'EpkBookingContactForm',
      'shopifyContactFormSection'
    ].forEach(function (id) {
      var form = document.getElementById(id);
      if (form) form.setAttribute('data-shopify-captcha', 'true');
    });
  }

  markShopifyCaptchaForms();

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getLessonModalTrigger(target) {
    if (!target || !target.closest) return null;

    return target.closest([
      '.js-apply-lessons',
      '.lessons-apply-trigger',
      '[data-open-lessons-modal]',
      'a[href*="/pages/lesson-application"]',
      'a[href="#lesson-application"]',
      'a[href="#lessons-form-modal"]'
    ].join(','));
  }

  function openLessonsApplicationModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    markShopifyCaptchaForms();

    var modal = document.querySelector('[data-lessons-form-modal]');
    if (!modal) {
      if (window.location.pathname !== '/pages/lessons') {
        window.location.href = '/pages/lessons#lessons-form-modal';
      } else if (window.location.hash !== '#lessons-form-modal') {
        window.location.hash = 'lessons-form-modal';
      }
      return false;
    }

    if (window.openLessonsFormModal && window.openLessonsFormModal !== openLessonsApplicationModal) {
      window.openLessonsFormModal();
      return false;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('inert');
    document.documentElement.classList.add('modal-open');

    setTimeout(function () {
      var focusTarget = modal.querySelector('.sa-global-modal__dialog, input, select, textarea, button');
      if (focusTarget && focusTarget.focus) focusTarget.focus();
    }, 0);

    return false;
  }

  document.addEventListener('click', function (event) {
    var trigger = getLessonModalTrigger(event.target);
    if (!trigger) return;

    openLessonsApplicationModal(event);
  }, true);

  ready(function () {
    markShopifyCaptchaForms();

    if (window.location.hash === '#lessons-form-modal' || window.location.hash === '#lesson-application') {
      openLessonsApplicationModal();
    }
  });

  window.openLessonsFormModal = window.openLessonsFormModal || openLessonsApplicationModal;

  function themeRoute(key, fallback) {
    return (window.themeRoutes && window.themeRoutes[key]) || fallback;
  }

  function themeJsonRoute(key, fallback) {
    return themeRoute(key, fallback) + '.js';
  }

  // Sticky Header
  const header = document.querySelector('.site-header');
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', () => {
      requestAnimationFrame(handleScroll);
    }, { passive: true });

    // Initial check
    handleScroll();
  }

  // Theme toggle
  function initThemeToggle() {
    var key = 'theme';
    var html = document.documentElement;
    var stored = null;
    try {
      stored = window.flPreferenceStorage.getItem(key);
    } catch (e) { }

    var initial = stored;
    if (!initial) {
      // Default to dark for flagship 2027 aesthetic
      initial = 'dark';
    }
    html.setAttribute('data-theme', initial);

    var toggle = document.querySelector('[data-theme-toggle]');
    if (!toggle) return;

    function updateState(theme) {
      html.setAttribute('data-theme', theme);
      try {
        window.flPreferenceStorage.setItem(key, theme);
      } catch (e) { }
      toggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    }

    updateState(initial);

    toggle.addEventListener('click', function () {
      var current = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      updateState(current);
    });
  }

  // Shop filters and sort
  function initShopFilters() {
    var grid = document.querySelector('[data-shop-grid]') || document.querySelector('[data-product-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    if (cards.length === 0) {
      cards = Array.prototype.slice.call(grid.querySelectorAll('.product-grid__item'));
    }

    var filterButtons = document.querySelectorAll('[data-shop-filter], [data-role-filter], [data-filter-tag]');
    var sortSelect = document.querySelector('[data-shop-sort]') || document.querySelector('[data-sort-select]');

    function applyFilter(filter) {
      filterButtons.forEach(function (btn) {
        var btnFilter = btn.getAttribute('data-shop-filter') || btn.getAttribute('data-role-filter') || btn.getAttribute('data-filter-tag');
        btn.classList.toggle('is-active', btnFilter === filter);
      });

      cards.forEach(function (card) {
        // Handle both direct card attributes and nested product-card attributes
        var cardEl = card.querySelector('[data-product-card]') || card;
        var tags = (cardEl.getAttribute('data-tags') || '').toLowerCase();

        var show = true;
        if (filter && filter !== 'all') {
          // Check for exact tag match or partial match for specific categories
          if (filter === 'tabs') {
            show = tags.indexOf('tab') !== -1 || tags.indexOf('tabs') !== -1;
          } else if (filter === 'tone') {
            show = tags.indexOf('tone') !== -1 || tags.indexOf('tones') !== -1 || tags.indexOf('tone-pack') !== -1;
          } else if (filter === 'backing') {
            show = tags.indexOf('backing') !== -1 || tags.indexOf('backing-track') !== -1;
          } else if (filter === 'stems') {
            show = tags.indexOf('stems') !== -1 || tags.indexOf('multitracks') !== -1;
          } else if (filter === 'lesson') {
            show = tags.indexOf('lesson') !== -1 || tags.indexOf('lessons') !== -1 || tags.indexOf('masterclass') !== -1 || tags.indexOf('course') !== -1;
          } else if (filter === 'merch') {
            show = tags.indexOf('merch') !== -1 || tags.indexOf('merchandise') !== -1 || tags.indexOf('shirt') !== -1 || tags.indexOf('hoodie') !== -1;
          } else if (filter === 'bundle') {
            show = tags.indexOf('bundle') !== -1 || tags.indexOf('pack') !== -1;
          } else {
            // Generic tag match
            show = tags.indexOf(filter) !== -1;
          }
        }

        // Toggle visibility
        if (card.classList.contains('product-grid__item')) {
          card.style.display = show ? '' : 'none';
        } else {
          card.style.display = show ? '' : 'none';
          card.style.opacity = show ? '' : '0';
        }
      });

      // Announce filter results to screen readers
      var visibleCount = cards.filter(function (c) { return c.style.display !== 'none'; }).length;
      var liveRegion = document.getElementById('filter-live-region');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'filter-live-region';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('role', 'status');
        liveRegion.className = 'visually-hidden';
        grid.parentNode.insertBefore(liveRegion, grid);
      }
      liveRegion.textContent = visibleCount + ' product' + (visibleCount !== 1 ? 's' : '') + ' shown';
    }

    function applySort(mode) {
      var items = cards.slice();
      items.sort(function (a, b) {
        var cardA = a.querySelector('[data-product-card]') || a;
        var cardB = b.querySelector('[data-product-card]') || b;

        var priceA = parseFloat(cardA.getAttribute('data-price') || '0');
        var priceB = parseFloat(cardB.getAttribute('data-price') || '0');

        var titleElA = cardA.querySelector('.product-card__title');
        var titleElB = cardB.querySelector('.product-card__title');
        var titleA = titleElA ? titleElA.textContent.trim().toLowerCase() : '';
        var titleB = titleElB ? titleElB.textContent.trim().toLowerCase() : '';

        var dateA = parseInt(cardA.getAttribute('data-created') || '0');
        var dateB = parseInt(cardB.getAttribute('data-created') || '0');

        if (mode === 'price-ascending') return priceA - priceB;
        if (mode === 'price-descending') return priceB - priceA;
        if (mode === 'title-ascending') return titleA.localeCompare(titleB);
        if (mode === 'title-descending') return titleB.localeCompare(titleA);
        if (mode === 'created-descending') return dateB - dateA;
        if (mode === 'created-ascending') return dateA - dateB;

        // Legacy sort values
        if (mode === 'price-asc') return priceA - priceB;
        if (mode === 'price-desc') return priceB - priceA;
        if (mode === 'title-asc') return titleA.localeCompare(titleB);
        if (mode === 'title-desc') return titleB.localeCompare(titleA);

        return 0;
      });

      items.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-shop-filter') || btn.getAttribute('data-role-filter') || btn.getAttribute('data-filter-tag');
        applyFilter(filter);
      });
    });

    // Custom Sort Dropdown Logic
    var customSort = document.querySelector('[data-custom-sort]');
    if (customSort) {
      var trigger = customSort.querySelector('.custom-sort__trigger');
      var currentLabel = customSort.querySelector('[data-sort-current]');
      var options = customSort.querySelectorAll('.custom-sort__option');
      var checkIcon = '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><polyline points="10 3 4.5 9 2 6.5"/></svg>';

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        customSort.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', customSort.classList.contains('is-open'));
      });

      document.addEventListener('click', function (e) {
        if (!customSort.contains(e.target)) {
          customSort.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          var value = option.getAttribute('data-value');
          var label = option.getAttribute('data-label');

          // Update UI
          currentLabel.textContent = label;
          options.forEach(function (opt) {
            opt.classList.remove('is-active');
            opt.querySelector('.custom-sort__check').innerHTML = '';
          });
          option.classList.add('is-active');
          option.querySelector('.custom-sort__check').innerHTML = checkIcon;

          customSort.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');

          // Apply Sort
          applySort(value);
        });
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        applySort(sortSelect.value);
      });
    }

    // Initial filter check (optional, usually 'all' is default)
    // applyFilter('all'); 
  }


  // Collection toolbar filters and sort
  function initCollectionToolbar() {
    var grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-collection-product]'));
    var filterButtons = document.querySelectorAll('[data-collection-filter]');
    var sortSelect = document.querySelector('[data-collection-sort]');

    function applyFilter(filter) {
      filterButtons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-collection-filter') === filter || (filter === 'all' && btn.getAttribute('data-collection-filter') === 'all');
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').toLowerCase();
        var show = true;
        if (filter && filter !== 'all') {
          show = tags.indexOf(filter) !== -1;
        }
        card.style.display = show ? '' : 'none';
      });
    }

    function applySort(mode) {
      if (!sortSelect || !mode) return;
      var items = cards.slice();
      items.sort(function (a, b) {
        var ap = parseFloat(a.getAttribute('data-price') || '0');
        var bp = parseFloat(b.getAttribute('data-price') || '0');
        var at = (a.getAttribute('data-title') || '').toLowerCase();
        var bt = (b.getAttribute('data-title') || '').toLowerCase();
        var ad = parseInt(a.getAttribute('data-created') || '0', 10);
        var bd = parseInt(b.getAttribute('data-created') || '0', 10);

        if (mode === 'price-ascending') return ap - bp;
        if (mode === 'price-descending') return bp - ap;
        if (mode === 'alpha-ascending') return at < bt ? -1 : at > bt ? 1 : 0;
        if (mode === 'alpha-descending') return at > bt ? -1 : at < bt ? 1 : 0;
        if (mode === 'created-descending') return bd - ad;
        return 0;
      });
      items.forEach(function (card) { grid.appendChild(card); });
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-collection-filter'));
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        applySort(sortSelect.value);
      });
    }
  }
  // Discography modal, filters, sort
  function initDiscography() {
    var grid = document.querySelector('[data-discography-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-discography-card]'));
    if (!cards.length) return;

    var filterButtons = Array.prototype.slice.call(document.querySelectorAll('[data-discography-filter]'));
    var sortSelect = document.querySelector('[data-discography-sort]');
    var modal = document.getElementById('DiscographyModal');

    function applyFilter(filter) {
      if (!filterButtons.length) return;

      filterButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-discography-filter') === filter);
      });

      cards.forEach(function (card) {
        var category = card.getAttribute('data-category') || 'solo';
        var format = card.getAttribute('data-format') || 'album';
        var show = true;

        if (filter === 'solo') {
          show = category === 'solo';
        } else if (filter === 'albums') {
          show = format === 'album';
        } else if (filter === 'eps') {
          show = format === 'ep';
        } else if (filter === 'singles') {
          show = format === 'single';
        } else if (filter === 'guest') {
          show = category === 'guest';
        } else if (filter === 'production') {
          show = category === 'production';
        } else {
          show = true;
        }

        card.style.display = show ? '' : 'none';
      });
    }

    function showModePanel() {
      const panels = ['DelayGrid', 'ReverbPanel', 'ModulationPanel', 'SamplesPanel', 'FrequencyPanel'];
      panels.forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;

        let show = false;
        if (this.currentMode === 'delay' && id === 'DelayGrid') show = true;
        else if (this.currentMode === 'reverb' && id === 'ReverbPanel') show = true;
        else if (this.currentMode === 'modulation' && id === 'ModulationPanel') show = true;
        else if (this.currentMode === 'samples' && id === 'SamplesPanel') show = true;
        else if (this.currentMode === 'frequency' && id === 'FrequencyPanel') show = true;

        el.style.display = show ? 'block' : 'none';
      });
    }

    function applySort(mode) {
      if (!mode) return;
      var items = cards.slice(0);

      items.sort(function (a, b) {
        var yearA = parseInt(a.getAttribute('data-year') || '0', 10);
        var yearB = parseInt(b.getAttribute('data-year') || '0', 10);
        var titleA = (a.getAttribute('data-title') || '').toLowerCase();
        var titleB = (b.getAttribute('data-title') || '').toLowerCase();

        if (mode === 'az') {
          if (titleA < titleB) return -1;
          if (titleA > titleB) return 1;
          return 0;
        }
        if (mode === 'za') {
          if (titleA > titleB) return -1;
          if (titleA < titleB) return 1;
          return 0;
        }
        if (mode === 'oldest') {
          return yearA - yearB;
        }
        // default newest
        return yearB - yearA;
      });

      items.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function openDiscographyModal(card) {
      if (!modal) return;

      var title = card.getAttribute('data-title') || '';
      var year = card.getAttribute('data-year') || '';
      var typeLabel = card.getAttribute('data-type-label') || '';
      var description = card.getAttribute('data-description') || '';
      var tracklistRaw = card.getAttribute('data-tracklist') || '';
      var spotify = card.getAttribute('data-spotify') || '';
      var bandcamp = card.getAttribute('data-bandcamp') || '';
      var audio = card.getAttribute('data-audio') || '';
      var primaryUrl = card.getAttribute('data-primary-url') || '';
      var primaryLabel = card.getAttribute('data-primary-label') || '';
      var videoUrl = card.getAttribute('data-video-url') || '';
      var videoLabel = card.getAttribute('data-video-label') || '';
      var buyUrl = card.getAttribute('data-buy-url') || '';
      var buyLabel = card.getAttribute('data-buy-label') || '';
      var pressMode = card.getAttribute('data-press-mode') === 'true';
      var pressShort = card.getAttribute('data-press-short') || '';
      var pressFansOf = card.getAttribute('data-press-fans-of') || '';
      var pressLong = card.getAttribute('data-press-long') || '';
      var pressCredits = card.getAttribute('data-press-credits') || '';
      var pressPhoto1 = card.getAttribute('data-press-photo-1') || '';
      var pressPhoto2 = card.getAttribute('data-press-photo-2') || '';
      var pressPhoto3 = card.getAttribute('data-press-photo-3') || '';
      var tracklistLines = tracklistRaw.replace(/\r\n/g, '\n').split('\n').map(function (line) {
        return line.trim();
      }).filter(function (line) { return line.length > 0; });

      var artworkImg = card.querySelector('img');
      var artworkWrapper = modal.querySelector('#DiscographyModalArtworkWrapper');
      var titleEl = modal.querySelector('#DiscographyModalTitle');
      var metaEl = modal.querySelector('#DiscographyModalMeta');
      var headerMetaEl = modal.querySelector('#DiscographyModalHeaderMeta');
      var taglineEl = modal.querySelector('#DiscographyModalDescription');
      var audioEl = modal.querySelector('#DiscographyModalAudio');
      var overviewSection = modal.querySelector('#DiscographyModalOverviewSection');
      var overviewEl = modal.querySelector('#DiscographyModalOverview');
      var listenSection = modal.querySelector('#DiscographyModalListenSection');
      var tracklistSection = modal.querySelector('#DiscographyModalTracklistSection');
      var tracklistEl = modal.querySelector('#DiscographyModalTracklist');
      var creditsSection = modal.querySelector('#DiscographyModalCreditsSection');
      var creditsEl = modal.querySelector('#DiscographyModalCredits');
      var pressSection = modal.querySelector('#DiscographyModalPressSection');
      var pressEl = modal.querySelector('#DiscographyModalPress');
      var footerEl = modal.querySelector('.discography-modal__footer');
      var primaryEl = modal.querySelector('#DiscographyModalPrimary');
      var videoEl = modal.querySelector('#DiscographyModalVideo');
      var buyEl = modal.querySelector('#DiscographyModalBuy');
      var spotifyEl = modal.querySelector('#DiscographyModalSpotify');
      var bandcampEl = modal.querySelector('#DiscographyModalBandcamp');
      var discographyMode = modal.getAttribute('data-discography-mode') || 'fan';

      function toggleSection(section, shouldShow) {
        if (!section) return;
        section.classList.toggle('is-hidden', !shouldShow);
      }

      function renderParagraphs(container, text) {
        if (!container) return false;
        var value = (text || '').replace(/\r\n/g, '\n').trim();
        if (!value) {
          container.innerHTML = '';
          return false;
        }
        var blocks = value.split(/\n\s*\n/);
        container.innerHTML = '';
        blocks.forEach(function (block) {
          var clean = block.trim();
          if (!clean) return;
          var p = document.createElement('p');
          p.textContent = clean;
          container.appendChild(p);
        });
        return container.childNodes.length > 0;
      }

      function isButtonVisible(btn) {
        return !!(btn && !btn.classList.contains('is-hidden'));
      }

      if (artworkWrapper) {
        artworkWrapper.innerHTML = '';
        if (artworkImg && artworkImg.src) {
          var newImg = document.createElement('img');
          newImg.src = artworkImg.src;
          newImg.alt = artworkImg.alt || title;
          artworkWrapper.appendChild(newImg);
        } else {
          var ph = document.createElement('div');
          ph.className = 'discography-card__artwork-placeholder modal__artwork-placeholder';
          var span = document.createElement('span');
          span.textContent = year || '20XX';
          ph.appendChild(span);
          artworkWrapper.appendChild(ph);
        }
      }

      if (titleEl) titleEl.textContent = title;
      if (metaEl) metaEl.textContent = typeLabel || year;
      if (headerMetaEl) headerMetaEl.textContent = typeLabel || year;
      if (taglineEl) {
        var tagline = (description || '').replace(/\s+/g, ' ').trim();
        taglineEl.textContent = tagline;
        taglineEl.classList.toggle('is-hidden', !tagline.length);
      }

      var hasOverview = renderParagraphs(overviewEl, pressLong || (description ? description : ''));
      toggleSection(overviewSection, hasOverview);

      var hasCredits = renderParagraphs(creditsEl, pressCredits);
      toggleSection(creditsSection, hasCredits);

      var audioAdded = false;
      if (audioEl) {
        audioEl.innerHTML = '';
        if (audio) {
          var audioLabel = audioEl.getAttribute('data-audio-label') || '';
          if (audioLabel) {
            var p = document.createElement('p');
            p.className = 'discography-modal__audio-label';
            p.textContent = audioLabel;
            audioEl.appendChild(p);
          }
          var audioTag = document.createElement('audio');
          audioTag.controls = true;
          audioTag.src = audio;
          audioTag.preload = 'none';
          audioTag.className = 'discography-modal__audio-player';
          audioEl.appendChild(audioTag);
          audioAdded = true;
        }
        audioEl.classList.toggle('is-hidden', !audioAdded);
      }

      if (tracklistEl) {
        tracklistEl.innerHTML = '';
        if (tracklistLines.length) {
          var list = document.createElement('ol');
          list.className = 'discography-modal__tracklist-list';
          tracklistLines.forEach(function (line) {
            var li = document.createElement('li');
            li.textContent = line;
            list.appendChild(li);
          });
          tracklistEl.appendChild(list);
        }
      }
      toggleSection(tracklistSection, tracklistLines.length > 0);

      if (pressEl) {
        pressEl.innerHTML = '';
        var pressPhotos = [pressPhoto1, pressPhoto2, pressPhoto3].filter(function (url) { return !!url; });
        var hasPress = pressMode && (pressShort || pressFansOf || pressPhotos.length);
        if (hasPress) {
          if (pressShort) {
            var blurb = document.createElement('p');
            blurb.className = 'discography-modal__press-short';
            blurb.textContent = pressShort;
            pressEl.appendChild(blurb);
          }
          if (pressFansOf) {
            var fans = document.createElement('p');
            fans.className = 'discography-modal__press-meta';
            fans.textContent = 'For fans of ' + pressFansOf;
            pressEl.appendChild(fans);
          }
          if (tracklistLines.length) {
            var focus = document.createElement('p');
            focus.className = 'discography-modal__press-focus';
            focus.textContent = 'Focus track: ' + tracklistLines[0];
            pressEl.appendChild(focus);
          }
          if (pressPhotos.length) {
            var photosHeading = pressEl.getAttribute('data-photos-heading') || '';
            if (photosHeading) {
              var photosTitle = document.createElement('p');
              photosTitle.className = 'discography-modal__press-photos-heading';
              photosTitle.textContent = photosHeading;
              pressEl.appendChild(photosTitle);
            }
            var photosList = document.createElement('div');
            photosList.className = 'discography-modal__press-photos';
            pressPhotos.forEach(function (url) {
              var link = document.createElement('a');
              link.href = url;
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
              link.className = 'discography-modal__press-photo-link';
              var img = document.createElement('img');
              img.src = url;
              img.alt = title + ' press photo';
              link.appendChild(img);
              photosList.appendChild(link);
            });
            pressEl.appendChild(photosList);
          }
        }
        toggleSection(pressSection, !!(pressEl && pressEl.childNodes.length));
      }

      function setupButton(el, url, label) {
        if (!el) return false;
        if (url) {
          el.href = url;
          if (label) {
            el.textContent = label;
          }
          el.classList.remove('is-hidden');
          return true;
        }
        el.classList.add('is-hidden');
        return false;
      }

      setupButton(primaryEl, primaryUrl, primaryLabel);
      setupButton(videoEl, videoUrl, videoLabel);
      setupButton(buyEl, buyUrl, buyLabel);
      setupButton(spotifyEl, spotify, null);
      setupButton(bandcampEl, bandcamp, null);

      if (discographyMode === 'press') {
        [primaryEl, videoEl, buyEl, spotifyEl, bandcampEl].forEach(function (btn) {
          if (btn) btn.classList.add('is-hidden');
        });
      }

      var listenHasButtons = [primaryEl, videoEl, spotifyEl, bandcampEl].some(isButtonVisible);
      toggleSection(listenSection, listenHasButtons || audioAdded);

      var footerHasButton = isButtonVisible(buyEl);
      toggleSection(footerEl, footerHasButton);

      if (typeof openModalElement === 'function') {
        openModalElement(modal);
      } else {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
      }
    }

    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-discography-open]') || card;
      if (!trigger) return;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDiscographyModal(card);
      });
    });

    if (filterButtons.length) {
      filterButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var filter = btn.getAttribute('data-discography-filter') || 'all';
          applyFilter(filter);
        });
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        applySort(this.value || 'newest');
      });
      applySort(sortSelect.value || 'newest');
    }

    applyFilter('all');
  } function openModal(card) {
    if (!modal) return;
    var title = card.getAttribute('data-title') || '';
    var year = card.getAttribute('data-year') || '';
    var typeLabel = card.getAttribute('data-type-label') || '';
    var description = card.getAttribute('data-description') || '';
    var tracklistRaw = card.getAttribute('data-tracklist') || '';
    var spotify = card.getAttribute('data-spotify') || '';
    var bandcamp = card.getAttribute('data-bandcamp') || '';
    var audio = card.getAttribute('data-audio') || '';
    var primaryUrl = card.getAttribute('data-primary-url') || '';
    var primaryLabel = card.getAttribute('data-primary-label') || '';
    var videoUrl = card.getAttribute('data-video-url') || '';
    var videoLabel = card.getAttribute('data-video-label') || '';
    var buyUrl = card.getAttribute('data-buy-url') || '';
    var buyLabel = card.getAttribute('data-buy-label') || '';
    var pressMode = card.getAttribute('data-press-mode') === 'true';
    var pressShort = card.getAttribute('data-press-short') || '';
    var pressFansOf = card.getAttribute('data-press-fans-of') || '';
    var pressLong = card.getAttribute('data-press-long') || '';
    var pressCredits = card.getAttribute('data-press-credits') || '';
    var pressPhoto1 = card.getAttribute('data-press-photo-1') || '';
    var pressPhoto2 = card.getAttribute('data-press-photo-2') || '';
    var pressPhoto3 = card.getAttribute('data-press-photo-3') || '';

    var artworkImg = card.querySelector('img');
    var artworkWrapper = modal.querySelector('#DiscographyModalArtworkWrapper');
    var yearLabel = modal.querySelector('#DiscographyModalYear');
    var titleEl = modal.querySelector('#DiscographyModalTitle');
    var metaEl = modal.querySelector('#DiscographyModalMeta');
    var descEl = modal.querySelector('#DiscographyModalDescription');
    var audioEl = modal.querySelector('#DiscographyModalAudio');
    var tracklistEl = modal.querySelector('#DiscographyModalTracklist');
    var pressEl = modal.querySelector('#DiscographyModalPress');
    var primaryEl = modal.querySelector('#DiscographyModalPrimary');
    var videoEl = modal.querySelector('#DiscographyModalVideo');
    var buyEl = modal.querySelector('#DiscographyModalBuy');
    var spotifyEl = modal.querySelector('#DiscographyModalSpotify');
    var bandcampEl = modal.querySelector('#DiscographyModalBandcamp');

    if (artworkWrapper) {
      artworkWrapper.innerHTML = '';
      if (artworkImg && artworkImg.src) {
        var newImg = document.createElement('img');
        newImg.src = artworkImg.src;
        newImg.alt = artworkImg.alt || title;
        artworkWrapper.appendChild(newImg);
      } else {
        var ph = document.createElement('div');
        ph.className = 'discography-card__artwork-placeholder modal__artwork-placeholder';
        var span = document.createElement('span');
        span.textContent = year || '20XX';
        ph.appendChild(span);
        artworkWrapper.appendChild(ph);
      }
    }

    if (yearLabel) yearLabel.textContent = year || '20XX';
    if (titleEl) titleEl.textContent = title;
    if (metaEl) metaEl.textContent = typeLabel || year;
    if (descEl) {
      var desc = description || '';
      desc = desc.replace(/\s+/g, ' ').trim();
      descEl.textContent = desc;
    }

    if (audioEl) {
      audioEl.innerHTML = '';
      if (audio) {
        var audioLabel = audioEl.getAttribute('data-audio-label') || '';
        if (audioLabel) {
          var p = document.createElement('p');
          p.className = 'discography-modal__audio-label';
          p.textContent = audioLabel;
          audioEl.appendChild(p);
        }
        var audioTag = document.createElement('audio');
        audioTag.controls = true;
        audioTag.src = audio;
        audioTag.preload = 'none';
        audioTag.className = 'discography-modal__audio-player';
        audioEl.appendChild(audioTag);
      }
    }

    if (tracklistEl) {
      tracklistEl.innerHTML = '';
      var tlLines = tracklistRaw.replace(/\r\n/g, '\n').split('\n').map(function (line) {
        return line.trim();
      }).filter(function (line) { return line.length > 0; });
      if (tlLines.length) {
        var label = document.createElement('p');
        label.textContent = tracklistEl.getAttribute('data-tracklist-label') || 'Tracklist';
        tracklistEl.appendChild(label);
        var ul = document.createElement('ul');
        tlLines.forEach(function (line) {
          var li = document.createElement('li');
          li.textContent = line;
          ul.appendChild(li);
        });
        tracklistEl.appendChild(ul);
      }
    }

    if (pressEl) {
      pressEl.innerHTML = '';
      if (pressMode && (pressShort || pressLong || pressCredits || pressPhoto1 || pressPhoto2 || pressPhoto3)) {
        var headingText = pressEl.getAttribute('data-press-heading') || '';
        if (headingText) {
          var h = document.createElement('h3');
          h.className = 'discography-modal__press-heading';
          h.textContent = headingText;
          pressEl.appendChild(h);
        }
        if (pressShort) {
          var ps = document.createElement('p');
          ps.className = 'discography-modal__press-short';
          ps.textContent = pressShort;
          pressEl.appendChild(ps);
        }
        if (pressLong) {
          var pl = document.createElement('p');
          pl.className = 'discography-modal__press-long';
          pl.textContent = pressLong;
          pressEl.appendChild(pl);
        }
        if (pressFansOf) {
          var fo = document.createElement('p');
          fo.className = 'discography-modal__press-fans-of';
          fo.textContent = pressFansOf;
          pressEl.appendChild(fo);
        }
        if (pressCredits) {
          var creditsHeading = pressEl.getAttribute('data-credits-heading') || '';
          if (creditsHeading) {
            var ch = document.createElement('h4');
            ch.className = 'discography-modal__press-credits-heading';
            ch.textContent = creditsHeading;
            pressEl.appendChild(ch);
          }
          var pc = document.createElement('p');
          pc.className = 'discography-modal__press-credits';
          pc.textContent = pressCredits;
          pressEl.appendChild(pc);
        }
        var photos = [pressPhoto1, pressPhoto2, pressPhoto3].filter(function (url) { return !!url; });
        if (photos.length) {
          var photosHeading = pressEl.getAttribute('data-photos-heading') || '';
          if (photosHeading) {
            var phH = document.createElement('h4');
            phH.className = 'discography-modal__press-photos-heading';
            phH.textContent = photosHeading;
            pressEl.appendChild(phH);
          }
          var photosList = document.createElement('div');
          photosList.className = 'discography-modal__press-photos';
          photos.forEach(function (url) {
            var a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            a.className = 'discography-modal__press-photo-link';
            var img = document.createElement('img');
            img.src = url;
            img.alt = title + ' press photo';
            a.appendChild(img);
            photosList.appendChild(a);
          });
          pressEl.appendChild(photosList);
        }
      }
    }

    function setupButton(el, url, label) {
      if (!el) return;
      if (url) {
        el.href = url;
        if (label) {
          el.textContent = label;
        }
        el.classList.remove('is-hidden');
      } else {
        el.classList.add('is-hidden');
      }
    }

    setupButton(primaryEl, primaryUrl, primaryLabel);
    setupButton(videoEl, videoUrl, videoLabel);
    setupButton(buyEl, buyUrl, buyLabel);
    setupButton(spotifyEl, spotify, null);
    setupButton(bandcampEl, bandcamp, null);

    openModalElement(modal);
  } function initGearGallery() {
    var grid = document.querySelector('[data-gear-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-gear-card]'));
    var filterButtons = document.querySelectorAll('[data-gear-filter]');
    var modal = document.getElementById('GearModal');

    function applyFilter(filter) {
      filterButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-gear-filter') === filter);
      });

      cards.forEach(function (card) {
        var category = card.getAttribute('data-category') || 'guitars';
        var show = true;
        if (filter === 'main') {
          show = category === 'main';
        } else if (filter === 'guitars') {
          show = category === 'guitars' || category === 'main';
        } else if (filter === 'amps_fx') {
          show = category === 'amps_fx';
        } else if (filter === 'studio') {
          show = category === 'studio';
        } else if (filter === 'plugins') {
          show = category === 'plugins';
        } else if (filter === 'everything') {
          show = true;
        }
        card.style.display = show ? '' : 'none';
      });
    }

    function openGearModal(card) {
      if (!modal) return;

      const name = card.getAttribute('data-name') || '';
      const brand = card.getAttribute('data-brand') || '';
      const role = card.getAttribute('data-role') || '';
      const description = card.getAttribute('data-note-from-sean') || card.getAttribute('data-description') || '';
      const specs = card.getAttribute('data-specs') || '';
      const serial = card.getAttribute('data-serial') || '';
      const strings = card.getAttribute('data-string-gauge') || '';
      const url = card.getAttribute('data-url') || '';
      const guitarTales = card.getAttribute('data-guitar-tales-url') || '';
      const videoId = card.getAttribute('data-video-url') || '';
      const videoType = card.getAttribute('data-video-type') || 'youtube';
      const imagesRaw = card.getAttribute('data-images') || '[]';
      const featuredOn = card.getAttribute('data-featured-on') || '';
      const relatedProductsRaw = card.getAttribute('data-related-products') || '[]';

      // Basic Info
      const titleEl = modal.querySelector('#GearModalTitle');
      const brandEl = modal.querySelector('#GearModalBrand');
      const roleEl = modal.querySelector('#GearModalRole');
      const descEl = modal.querySelector('#GearModalDescription');
      const specsEl = modal.querySelector('#GearModalSpecsContent');
      const serialEl = modal.querySelector('#GearModalSerial');
      const serialWrap = modal.querySelector('#GearModalSerialWrapper');
      const stringsEl = modal.querySelector('#GearModalStringVal');
      const stringsWrap = modal.querySelector('#GearModalStringsWrapper');

      if (titleEl) titleEl.textContent = name;
      if (brandEl) brandEl.textContent = brand;
      if (roleEl) roleEl.textContent = role;
      if (descEl) descEl.textContent = description;
      if (specsEl) specsEl.innerHTML = specs.replace(/\n/g, '<br>');

      if (serialEl && serialWrap) {
        serialEl.textContent = serial;
        serialWrap.classList.toggle('hidden', !serial);
      }
      if (stringsEl && stringsWrap) {
        stringsEl.textContent = strings;
        stringsWrap.classList.toggle('hidden', !strings);
      }

      // Media - Images
      const carousel = modal.querySelector('#GearModalCarousel');
      if (carousel) {
        carousel.innerHTML = '';
        try {
          const images = JSON.parse(imagesRaw);
          images.forEach(src => {
            if (!src) return;
            const item = document.createElement('div');
            item.className = 'gear-carousel__item';
            item.innerHTML = `<img src="${src}" alt="${name}" loading="lazy">`;
            carousel.appendChild(item);
          });
        } catch (e) { console.error('Error parsing images', e); }
      }

      // Media - Video
      const videoWrap = modal.querySelector('#GearModalVideo');
      if (videoWrap) {
        videoWrap.innerHTML = '';
        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = videoType === 'youtube'
            ? `https://www.youtube.com/embed/${videoId}`
            : `https://player.vimeo.com/video/${videoId}`;
          iframe.style.border = '0';
          iframe.setAttribute('allowfullscreen', '');
          videoWrap.appendChild(iframe);
          videoWrap.classList.remove('hidden');
        } else {
          videoWrap.classList.add('hidden');
        }
      }

      // Links
      const talesLink = modal.querySelector('#GearModalGuitarTales');
      if (talesLink) {
        if (guitarTales) {
          talesLink.href = guitarTales;
          talesLink.classList.remove('hidden');
        } else {
          talesLink.classList.add('hidden');
        }
      }

      const externalLink = modal.querySelector('#GearModalLink');
      if (externalLink) {
        if (url) {
          externalLink.href = url;
          externalLink.classList.remove('hidden');
        } else {
          externalLink.classList.add('hidden');
        }
      }

      // Related Releases
      const featuredSection = modal.querySelector('#GearModalFeatured');
      const featuredContent = modal.querySelector('#GearModalFeaturedContent');
      if (featuredSection && featuredContent) {
        if (featuredOn) {
          featuredContent.innerHTML = featuredOn.split('\n').map(l => `<span class="featured-tag">${l}</span>`).join('');
          featuredSection.classList.remove('hidden');
        } else {
          featuredSection.classList.add('hidden');
        }
      }

      // Related Products
      const relatedSection = modal.querySelector('#GearRelatedProducts');
      const relatedGrid = modal.querySelector('.gear-related__grid');
      if (relatedSection && relatedGrid) {
        relatedGrid.innerHTML = '';
        try {
          const products = JSON.parse(relatedProductsRaw);
          if (products && products.length > 0) {
            products.forEach(p => {
              const pCard = document.createElement('a');
              pCard.href = p.url;
              pCard.className = 'gear-related-item';
              pCard.innerHTML = `
                <div class="gear-related-item__image-wrapper">
                  <img src="${p.image}" class="gear-related-item__image" alt="${p.title}">
                </div>
                <div class="gear-related-item__content">
                  <div class="gear-related-item__info">
                    <h5 class="gear-related-item__title">${p.title}</h5>
                    <span class="gear-related-item__price">${p.price}</span>
                  </div>
                </div>
              `;
              relatedGrid.appendChild(pCard);
            });
            relatedSection.classList.remove('hidden');
          } else {
            relatedSection.classList.add('hidden');
          }
        } catch (e) {
          relatedSection.classList.add('hidden');
        }
      }

      openModalElement(modal);
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openGearModal(card);
      });
    });

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-gear-filter'));
      });
    });

    applyFilter('everything');
  }

  // Generic modal helpers with basic focus trap
  var currentModal = null;
  var lastFocusedElement = null;

  function openModalElement(modal) {
    if (!modal) return;
    currentModal = modal;
    lastFocusedElement = document.activeElement;

    if (window.SAModalController) {
      var modalConfig = {
        openClass: 'is-open',
        closeSelector: '[data-modal-close]',
        closeOnEscape: true,
        trapFocus: true
      };
      window.SAModalController.bind(modal, modalConfig);
      window.SAModalController.open(modal, modalConfig);
      return;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    var closeBtn = modal.querySelector('[data-modal-close]');
    if (closeBtn) {
      closeBtn.focus();
    }

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute('data-modal-close')) {
        closeModalElement(modal);
      }
    });
  }

  function closeModalElement(modal) {
    if (!modal) return;
    if (window.SAModalController) {
      window.SAModalController.close(modal, {
        openClass: 'is-open',
        closeSelector: '[data-modal-close]',
        closeOnEscape: true,
        trapFocus: true
      });
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
      currentModal = null;
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    currentModal = null;
  }

  function handleGlobalKeydown(e) {
    if (window.SAModalController) return;

    if (e.key === 'Escape' && currentModal) {
      closeModalElement(currentModal);
    }
    if (e.key === 'Tab' && currentModal) {
      var focusable = currentModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusable = Array.prototype.slice.call(focusable).filter(function (el) {
        return !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden');
      });
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    }
  }

  // Accordion
  function initAccordion() {
    var accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;
        var item = trigger.closest('.accordion-item');
        if (!item) return;
        var open = item.classList.contains('is-open');
        if (open) {
          item.classList.remove('is-open');
        } else {
          item.classList.add('is-open');
        }
      });
    });
  }

  // AJAX add-to-cart: quick-add overlays, the PDP buy form, the song-template
  // tier cards, AND the flagship forms (fl-prod__form = PDP spec-sheet,
  // fl-pcard__form = product cards) all open the cart drawer instead of doing
  // a full-page jump to /cart (fix 2026-06-12; flagship classes added
  // 2026-07-04 — they were missing, so every flagship add-to-cart hard-navigated).
  // Neither flagship form has a quantity input, so the hardcoded qty 1 is safe.
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.quick-add-form, .product-form, .tier-card__form, .fl-prod__form, .fl-pcard__form');
      if (!form) return;
      if (e.submitter && (e.submitter.name === 'checkout' || e.submitter.closest('.shopify-payment-button'))) return;
      e.preventDefault();
      e.stopPropagation();

      var id = form.querySelector('input[name="id"]').value;
      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (input) {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match && input.value) properties[match[1]] = input.value;
      });
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('loading'); btn.disabled = true; }

      if (window.cartDrawer) {
        window.cartDrawer.addItem(id, 1, properties)
          .then(function () {
            if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
          })
          .catch(function () {
            if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
          });
      } else {
        fetch(themeJsonRoute('cartAdd', '/cart/add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1, properties: properties })
        }).then(function (res) {
          if (res && res.ok) {
            window.dispatchEvent(new Event('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
        }).catch(function () {
          if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
        });
      }
    }, true);
  }

  ready(function () {
    window.flRunWhenPrivacyReady(initThemeToggle);
    initShopFilters();
    initCollectionToolbar();
    initDiscography();
    initQuickAdd();
    initHeroCarousels();
    // initGearGallery(); // Removed redundant call if handled in section liquid
    initLessonsLibrary();
    initGalleryGrid();
    initTestimonialsCarousel();
    initSongBundlePanel();
    initAccordion();
    document.addEventListener('keydown', handleGlobalKeydown);
  });
})();




// Lessons library filters
function initLessonsLibrary() {
  var sections = document.querySelectorAll('[data-lessons-library]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-lesson-card]'));
    if (!cards.length) return;
    var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-lesson-filter]'));

    function applyFilter(filter) {
      filterButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-lesson-filter') === filter);
      });
      cards.forEach(function (card) {
        if (filter === 'all') {
          card.style.display = '';
          return;
        }
        var tags = (card.getAttribute('data-tags') || '').toLowerCase();
        var needle = filter.toLowerCase();
        card.style.display = tags.indexOf(needle) !== -1 ? '' : 'none';
      });
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-lesson-filter'));
      });
    });

    applyFilter('all');
  });
}

// Gallery grid lightbox
function initGalleryGrid() {
  var grids = document.querySelectorAll('.gallery-grid');
  if (!grids.length) return;

  grids.forEach(function (section) {
    var lightbox = section.querySelector('[data-gallery-lightbox]');
    if (!lightbox) return;
    var imgEl = lightbox.querySelector('img');

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-gallery-image]');
      if (trigger) {
        var img = trigger.querySelector('img');
        if (img && imgEl) {
          imgEl.src = img.src;
          imgEl.alt = img.alt || '';
        }
        lightbox.hidden = false;
      }
      if (event.target.closest('[data-gallery-close]')) {
        lightbox.hidden = true;
      }
    });
  });
}

// Hero carousel utility
function initHeroCarousels() {
  var carousels = document.querySelectorAll('[data-hero-carousel]');
  if (!carousels.length) return;

  carousels.forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-dot]'));
    var prevBtn = carousel.querySelector('[data-hero-prev]');
    var nextBtn = carousel.querySelector('[data-hero-next]');
    var autoplay = carousel.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(carousel.getAttribute('data-interval') || '7000', 10);
    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (activeIndex < 0) activeIndex = 0;
    var timer = null;

    function showSlide(index) {
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === index);
      });
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === index);
        dot.setAttribute('aria-current', idx === index ? 'true' : 'false');
      });
      activeIndex = index;
    }

    function next() {
      showSlide((activeIndex + 1) % slides.length);
    }

    function prev() {
      showSlide((activeIndex - 1 + slides.length) % slides.length);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    showSlide(activeIndex);

    if (prevBtn && slides.length > 1) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }

    if (nextBtn && slides.length > 1) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        showSlide(idx);
        restartAutoplay();
      });
    });

    if (autoplay && slides.length > 1) {
      timer = setInterval(next, interval);
    }
  });
}

// Testimonials carousel (simple fade)
function initTestimonialsCarousel() {
  var sections = document.querySelectorAll('[data-testimonials-carousel]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-testimonial-slide]'));
    if (!slides.length) return;
    var index = 0;
    var autoRotateInterval = null;

    function show(i) {
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === i);
      });
      var dots = section.querySelectorAll('[data-carousel-dot]');
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === i);
      });
    }

    function next() {
      index = (index + 1) % slides.length;
      show(index);
    }

    function prev() {
      index = (index - 1 + slides.length) % slides.length;
      show(index);
    }

    function goTo(i) {
      index = i;
      show(index);
    }

    show(index);

    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var dots = section.querySelectorAll('[data-carousel-dot]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        if (autoRotateInterval) {
          clearInterval(autoRotateInterval);
          startAutoRotate();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        if (autoRotateInterval) {
          clearInterval(autoRotateInterval);
          startAutoRotate();
        }
      });
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        goTo(idx);
        if (autoRotateInterval) {
          clearInterval(autoRotateInterval);
          startAutoRotate();
        }
      });
    });

    function startAutoRotate() {
      var interval = parseInt(section.getAttribute('data-rotate-ms') || '7000', 10);
      if (interval > 0) {
        autoRotateInterval = setInterval(next, interval);
      }
    }

    startAutoRotate();
  });
}

// Song bundle panel - Add all to cart
function initSongBundlePanel() {
  var forms = document.querySelectorAll('[data-add-all-form]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inputs = form.querySelectorAll('input[name="items[]"]');
      var items = Array.prototype.slice.call(inputs).map(function (input) {
        return input.value;
      }).filter(function (val) { return val; });

      if (items.length === 0) return;

      var formData = new FormData();
      items.forEach(function (id, idx) {
        formData.append('items[' + idx + '][id]', id);
        formData.append('items[' + idx + '][quantity]', 1);
      });

      fetch(themeJsonRoute('cartAdd', '/cart/add'), {
        method: 'POST',
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (typeof window.dispatchEvent !== 'undefined') {
          window.dispatchEvent(new Event('cart:updated'));
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.location !== 'undefined') {
          window.location.href = themeRoute('cart', '/cart');
        }
      }).catch(function (error) {
        console.error('Error adding items to cart:', error);
      });
    });
  });
}
// Initialize Lenis Smooth Scroll
/*
if (typeof Lenis !== 'undefined') {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
}
*/

// Connect Lenis to ScrollTrigger if available (optional future proofing)
// if (typeof ScrollTrigger !== 'undefined') {
//     lenis.on('scroll', ScrollTrigger.update);
//     gsap.ticker.add((time)=>{
//         lenis.raf(time * 1000);
//     });
//     gsap.ticker.lagSmoothing(0);
// }



// Enhanced Header Scroll Effects
function initEnhancedHeader() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var lastScrollY = window.scrollY;
  var ticking = false;

  function updateHeader() {
    var scrollY = window.scrollY;

    // Add scrolled class for background blur
    if (scrollY > 50) {
      header.classList.add('scrolled');
      header.classList.add('is-scrolled');
      header.setAttribute('data-scrolled', 'true');
    } else {
      header.classList.remove('scrolled');
      header.classList.remove('is-scrolled');
      header.setAttribute('data-scrolled', 'false');
    }

    // Optional: Hide header on scroll down, show on scroll up
    // Uncomment if desired:
    // if (scrollY > lastScrollY && scrollY > 150) {
    //   header.style.transform = 'translateY(-100%)';
    // } else {
    //   header.style.transform = 'translateY(0)';
    // }

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  // Initial state
  updateHeader();
}



// Card Mouse Tracking (spotlight effect)
function initCardMouseTracking() {
  return;
  // Skip on touch devices
  if ('ontouchstart' in window) return;

  var cards = document.querySelectorAll('.neuro-card, .product-card, .gear-card, .discography-card, .lesson-offer-card, .video-card');

  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;

      card.style.setProperty('--mouse-x', x + '%');
      card.style.setProperty('--mouse-y', y + '%');
    });

    // Reset position when mouse leaves
    card.addEventListener('mouseleave', function () {
      card.style.setProperty('--mouse-x', '50%');
      card.style.setProperty('--mouse-y', '50%');
    });
  });
}



// Premium Button Interactions
function initPremiumButtons() {
  return;
  var primaryButtons = document.querySelectorAll('.sa-btn-primary, .btn-primary');

  primaryButtons.forEach(function (btn) {
    // Add magnetic effect on hover
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;

      // Subtle magnetic pull
      btn.style.transform = 'translateY(-3px) translateX(' + (x * 0.1) + 'px) translateY(' + (y * 0.1) + 'px) scale(1.02)';
    });

    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  });
}

// Initialize all premium features
function initPremiumFeatures() {
  initEnhancedHeader();
  initCardMouseTracking();
  initPremiumButtons();
}

// Run on DOM ready
document.addEventListener('DOMContentLoaded', initPremiumFeatures);

// Public practice room: eight tools share one shell. Retired rewards/profile
// routes and unverified warmup/drone routes stay off the public surface.
(function () {
  var hiddenToolPathPattern = /\/pages\/(drone|warmup|ashe-rewards|members-dashboard)(\/)?$/i;
  var hiddenToolHrefPattern = /\/pages\/(drone|warmup|ashe-rewards|members-dashboard)([#?\/]|$)/i;

  function removeNode(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  function scrubToolsAndCoins() {
    // Shelved surfaces redirect away; the canonical eight-tool suite stays live.
    if (hiddenToolPathPattern.test(window.location.pathname)) {
      window.location.replace('/');
      return;
    }
    // Strip links to surfaces that do not have a public Shopify page yet.
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (hiddenToolHrefPattern.test(link.getAttribute('href') || '')) {
        removeNode(link.closest('li') || link);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', scrubToolsAndCoins);
  window.addEventListener('pageshow', scrubToolsAndCoins);
})();

// Force Klaviyo to re-initialize on every page load (fixes most silent-fail cases)
// Klaviyo initialization is handled by the script in theme.liquid
// document.addEventListener('DOMContentLoaded', function () {
//   if (window.klaviyo && window.klaviyo.push) {
//     window.klaviyo.push(['init']);
//   }
// });

// Booking Modal - open/close/delegation handled by epk-booking-modal.liquid inline script
